let _apiurl = process.env.VUE_APP_APIURL;
let _mode = process.env.VUE_APP_MODE;
let _version = process.env.VUE_APP_VERSION;

export let apiurl = _apiurl;
export let mode = _mode;
export let appVersion = _version;